import { render, staticRenderFns } from "./Submissions.vue?vue&type=template&id=cf75e3b2&scoped=true"
import script from "./Submissions.vue?vue&type=script&lang=js"
export * from "./Submissions.vue?vue&type=script&lang=js"
import style0 from "./Submissions.vue?vue&type=style&index=0&id=cf75e3b2&prod&scoped=true&lang=css"
import style1 from "./Submissions.vue?vue&type=style&index=1&id=cf75e3b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf75e3b2",
  null
  
)

export default component.exports